import React, { useEffect, useState } from "react";
import { CopyToClipboard } from "../../../../components/CopyToClipboard";
import { getEncryptedMnemonicFromStorage } from "../../../../utils/mnemonicStorage";
import { useAuth } from "../../../../hooks/useAuth";

const WORD_COUNT = 12;

interface SeedPhraseDisplayProps {
    ghostButton?: boolean;
}

export const SeedPhraseDisplay: React.FC<SeedPhraseDisplayProps> = ({ ghostButton = false }) => {
    const { pleb } = useAuth();
    const [mnemonicWords, setMnemonicWords] = useState<string[] | null>(null);
    const words = Array.from({ length: WORD_COUNT }, (_, i) => i + 1);

    useEffect(() => {
        if (!pleb?.id) {
            return;
        }
        let cancelled = false;
        void getEncryptedMnemonicFromStorage(pleb.id).then((stored) => {
            if (cancelled) return;
            if (stored && stored.type === "mnemonic" && stored.mnemonic) {
                setMnemonicWords(
                    stored.mnemonic
                        .trim()
                        .toLowerCase()
                        .split(/\s+/)
                );
            } else {
                setMnemonicWords([]);
            }
        });
        return () => {
            cancelled = true;
        };
    }, [pleb?.id]);

    if (mnemonicWords === null) {
        return (
            <div className="text-center text-sm opacity-70">
                Loading seed phrase...
            </div>
        );
    }

    if (mnemonicWords.length === 0) {
        return (
            <div className="text-center text-sm opacity-70">
                No seed phrase found on this device for this wallet.
            </div>
        );
    }

    return (
        <>
            <div className="grid grid-cols-2 gap-3">
                {words.map((index) => (
                    <div key={index} className="flex flex-col gap-1">
                        <div className="relative w-full">
                            <span className="absolute inset-y-0 left-3 flex items-center text-xs opacity-60">
                                {index}
                            </span>
                            <input
                                type="text"
                                readOnly
                                className="w-full rounded-full bg-brand-bg-4 pl-8 pr-3 py-2 text-sm outline-none border border-transparent"
                                value={mnemonicWords[index - 1] ?? ""}
                            />
                        </div>
                    </div>
                ))}
            </div>

            <div className="flex flex-col items-center gap-3 mt-2">
                <CopyToClipboard
                    className={ghostButton 
                        ? "py-2 px-4 text-sm rounded-full border border-brand-orange text-brand-orange hover:bg-brand-orange hover:text-white transition-colors"
                        : "py-2 px-4 text-sm rounded-full bg-brand-orange button-variant-primary text-white hover:opacity-90"
                    }
                    toCopy={mnemonicWords.join(" ")}
                    absolute={false}
                >
                    Copy seed
                </CopyToClipboard>
            </div>
        </>
    );
};
